import { useEffect } from "react";
import { Frame, Loading, Box } from "@shopify/polaris";
import { Link, Outlet, useLocation } from "react-router-dom";
import useFetchAppDataFB from "../hooks/useFetchAppDataFB";
import { useAppSelector } from "../redux/hooks";
import { getShop, getEmulating } from "../redux/slices/env";
import { NavMenu } from "@shopify/app-bridge-react";
import { useAppRouter } from "./hooks/useAppRouter";
import BottomBarEmulator from "./components/BottomBarEmulator";
import "./style.scss";

export default function Layout() {
  const loading = useFetchAppDataFB();
  const shop = useAppSelector(getShop);
  const emulating = useAppSelector(getEmulating);
  const location = useLocation();
  const { navLinks } = useAppRouter();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <NavMenu key={location.pathname}>
        <Link to={`/articles?shop=${shop}`} rel="home">Articles</Link>
        {navLinks.map(({ label, path }) => {
          if (path === "/articles") return null;
          return (
            <Link key={path} to={`${path}?shop=${shop}`}>
              {label}
            </Link>
          );
        })}
      </NavMenu>
      {loading ? (
        <Frame><Loading /></Frame>
      ) : (
        <Box paddingBlockEnd={emulating ? "1600" : undefined}>
          <Outlet />
          <BottomBarEmulator />
        </Box>
      )}
    </>
  );
}

